import { render, staticRenderFns } from "./RazonSocial.vue?vue&type=template&id=918c92e2&scoped=true"
import script from "./RazonSocial.vue?vue&type=script&lang=js"
export * from "./RazonSocial.vue?vue&type=script&lang=js"
import style0 from "./RazonSocial.vue?vue&type=style&index=0&id=918c92e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918c92e2",
  null
  
)

export default component.exports